module.exports = __webpack_public_path__ + "static/img/parents_bg.3fdc73b1.png";